<template>
  <div class="finish_room fr">
    <div class="finish_room2">
      <!-- <div v-for="(item, index) in imgurl" class="room_img" v-bind:key="index">
        <img :src="item" class="pimg" />
        <span @click="delete_img(index)">
          <img src="/static//imgs/img16.png" />
        </span>
      </div> -->

      <div class="room_add_img fcc" v-if='imgurl.length <9'>
        <!-- <img src="/static//imgs/img13.png" /> -->
        <!-- <span>点击上传图片</span> -->
        <input @change="add_img" type="file" ref="images" accept="image/*"/>
      </div>
    </div>
  </div>
</template>

<script >
import axios from "axios";
import * as Api from '@/api/Interface'
export default {
  name: "uploadImg",
  data: function () {
    return {
      imgs: [],
      imgurl: [],
      imgcontent: [
      ],
    };
  },
  methods: {
    delete_img(item) {
      console.log(this.imgurl)
      this.imgurl.splice(item, 1);
      this.imgs.splice(item, 1);
      this.imgcontent.splice(item, 1);
      console.log(this.imgurl)
    },


    add_img(event) {
      var fd = new FormData();
      var reader = new FileReader();
      var img1 = event.target.files[0];
      var img2 = this.$refs.images.files
      fd.append("code", this.$route.query.code)
      fd.append("img", img1)
      fd.append("key", localStorage.getItem('session_3rd'))
      reader.readAsDataURL(img1);
      var that = this;
      reader.onloadend = function () {
        Api.getImg(that.$axios, fd).then((res) => {
          if (res.code == 1) {
            console.log('上传图片成功')
            console.log(res.data.url)
            that.imgurl.push(res.data.url);
            that.imgs.push(res.data.uri);
            that.$emit('transmit', 1)
            var dd = {
              "img": res.data.uri,
              "type": "",
              "appid": "",
              "param": "",
              "url": "",
              "plan_id": 0
            }
            that.imgcontent.push(dd);
          } else {
            alert("文件过大")
          }
        })
        console.log(reader.result);



        // that.$axios
        //   .post(axios.defaults.imgURL + "/Upload/fileImgCheck", fd)
        //   .then((res) => {
        //     console.log(333)
        //     console.log(res)
        //     if (res.data.code == 1) {
        //       that.imgurl.push(res.data.data.url);
        //       that.imgs.push(res.data.data.uri);
        //       var dd = {
        //         "img": res.data.data.uri,
        //         "type": "",
        //         "appid": "",
        //         "param": "",
        //         "url": "",
        //         "plan_id": 0
        //       }
        //       that.imgcontent.push(dd);
        //     } else {
        //       alert("文件过大")
        //     }
        //   });

      };
    },
  },
};
</script>
<style scope>
.finish_room {
  width: 100%;
  height: auto;
  flex-wrap: wrap;
}

.finish_room2 {
  width: 100%;
  height: auto;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
    flex-wrap: wrap;
  align-items: center;
}

.finish_room2 .room_img {
  width: 120px;
  height: 120px;
  margin-right: 10px;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}

.finish_room2 .room_img img {
  width: 100%;
  height: 100%;
}

.pimg {
  object-fit: cover;
  image-rendering: -moz-crisp-edges;
  /* Firefox */
  image-rendering: -o-crisp-edges;
  /* Opera */
  image-rendering: -webkit-optimize-contrast;
  /* Webkit (non-standard naming) */
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
  /* IE (non-standard property) */
}

.finish_room2>.room_img span {
  position: absolute;
  width: auto;
  height: auto;
  right: 5px;
  bottom: 3px;
}

.room_add_img {
  width: 120px;
  height: 120px;
  padding: 34px 0 10px;
  box-sizing: border-box;
  /* border: 1px solid #e1e1e1; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.room_add_img>span {
  /* margin-top: 20px; */
  overflow: hidden;
  font-size: 12px;
  color: #8F8F8F;
}


.room_add_img input {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  margin: 0;
  height: 100%;
  z-index: 99999;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/uploadImg.vue